<template>
  <div>
    <p class="headline">{{$t('titles.selectOrCreate')}}</p>
    <p>{{$t('texts.infoCreateProject')}}</p>
    <v-combobox
      id="selectProject"
      :items="toSelect"
      @change="changeSelectedProj()"
      v-model="selectedProject"
      :label="$t('labels.chooseOrCreate')"
      color="primary"
      item-text="name"
      :placeholder="$t('placeholders.projSubProj')"
      :rules="[
      v => !!v || $t('errors.fieldRequired'),
      v => !!v && (v.split('/').length < 3) || 'Maximum one subproject'
      ]"
    ></v-combobox>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedProject: "",
      toSelect: [],
    };
  },
  props: {
    projects: Array
  },
  watch: {
    projects() {
      let projects = JSON.stringify(this.projects);
      projects = JSON.parse(projects);
      let parents = this.projParentsChilds(projects);
      let orderedParents = parents.sort((proj1, proj2) => {
        if(proj1.toLowerCase() < proj2.toLowerCase()) return -1;
        return 1;
      });
      this.toSelect = orderedParents;
    }
  },
  methods: {
    // Récupération des projets (au created + router)
    // Quand projets récupérés, création du select parent/enfants
    // =================
    changeSelected(name) {
      this.selectedCategory = name;
    },
    changeSelectedProj() {
      this.$emit('changeSelect', this.selectedProject);
    }
  }
}
</script>

<style lang="sass" scoped>
p.headline 
  margin-right: -70px
</style>
